'use strict';

const handleBingClaimLocationsSocket = (window, listingsManagerUrl, site, pmtElmService) => {
	const io = window.io;
	function socketInit() {
		const baseUrl = listingsManagerUrl
			.replace('https', 'wss')
			.replace('http', 'ws')
			.replace('/listings/', '/');
		const socketUrl = baseUrl + 'info';

		return io.connect(socketUrl, {
			query: 'site=' + site,
			transports: ['websocket'],
			path: '/listings/socket.io'
		});
	}
	const socket = socketInit();
	socket.on('bingSyncLocations', msg => {
		pmtElmService.sendData(
			'Tasks.Bing.Claim.Main',
			`in_Tasks_Bing_Claim_Main_syncLocations`,
			msg.msg.lastRun
		);
	});
};

module.exports = { handleBingClaimLocationsSocket };
